/* eslint-disable */

module.exports = [
    {
		"domain": "tv",
		"type": "brand",
		"id": "b07pn8mz",
		"title": "Poldark",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p043pk21.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/b07pn8mz"
	},
	{
		"domain": "tv",
		"type": "brand",
		"id": "b0071b63",
		"title": "The Apprentice",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p0495sxb.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/b0071b63"
	},
	{
		"domain": "music",
		"type": "playlist",
		"id": "zzzz48",
		"title": "Hottest Records in the World",
		"product": "Music",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p03vfgl3.jpg",
		"link": "http://www.bbc.co.uk/music/playlists/zzzz48"
	},
	{
		"domain": "tv",
		"type": "brand",
		"id": "b006m8dq",
		"title": "Strictly Come Dancing",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p0342n7k.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/b006m8dq"
	},
	{
		"domain": "music",
		"type": "artist",
		"id": "38f59974-2f4d-4bfa-b2e3-d2696de1b675",
		"title": "Little Mix",
		"product": "Music",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p01klwly.jpg",
		"link": "http://www.bbc.co.uk/music/artists/38f59974-2f4d-4bfa-b2e3-d2696de1b675"
	},
	{
		"domain": "tv",
		"type": "brand",
		"id": "b07zyh6k",
		"title": "Asian Provocateur",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p04b1qkh.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/b07zyh6k"
	},
	{
		"domain": "tv",
		"type": "brand",
		"id": "b013pqnm",
		"title": "The Great British Bake Off",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p02y7lkd.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/b013pqnm"
	},
	{
		"domain": "music",
		"type": "artist",
		"id": "e9c832b0-384b-4ee6-aec0-111372784aac",
		"title": "Pretenders",
		"product": "Music",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p01bqlq9.jpg",
		"link": "http://www.bbc.co.uk/music/artists/e9c832b0-384b-4ee6-aec0-111372784aac"
	},
	{
		"domain": "tv",
		"type": "brand",
		"id": "b006mkw3",
		"title": "Have I Got News For You",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p01m5376.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/b006mkw3"
	},
	{
		"domain": "tv",
		"type": "brand",
		"id": "p0295tcf",
		"title": "The Fall",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p048krn1.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/p0295tcf"
	},
	{
		"domain": "music",
		"type": "playlist",
		"id": "zzzzx2",
		"title": "Radio 2 Playlist",
		"product": "Music",
		"image": "https://ichef.bbc.co.uk/images/ic/$recipe/p038b58w.jpg",
		"link": "http://www.bbc.co.uk/music/playlists/zzzzx2"
	},
	{
		"domain": "tv",
		"type": "brand",
		"id": "b006m86d",
		"title": "EastEnders",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p01vg679.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/b006m86d"
	},
	{
		"domain": "music",
		"type": "playlist",
		"id": "zzzz8v",
		"title": "BBC 6 Music Recommends",
		"product": "Music",
		"image": "https://ichef.bbc.co.uk/images/ic/$recipe/p038b76r.jpg",
		"link": "http://www.bbc.co.uk/music/playlists/zzzz8v"
	},
	{
		"domain": "tv",
		"type": "brand",
		"id": "b006xnzc",
		"title": "The Graham Norton Show",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p01lcf3c.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/b006xnzc"
	},
	{
		"domain": "tv",
		"type": "brand",
		"id": "b006t14n",
		"title": "Panorama",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p01lyn5j.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/b006t14n"
	},
	{
		"domain": "music",
		"type": "artist",
		"id": "67fd5116-7a49-4abf-a34f-b08774128a7a",
		"title": "Stormzy",
		"product": "Music",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p02flslt.jpg",
		"link": "http://www.bbc.co.uk/music/artists/67fd5116-7a49-4abf-a34f-b08774128a7a"
	},
	{
		"domain": "tv",
		"type": "brand",
		"id": "b07xt09g",
		"title": "The Missing",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p049yzc6.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/b07xt09g"
	},
	{
		"domain": "tv",
		"type": "brand",
		"id": "b07xd230",
		"title": "Josh",
		"product": "iPlayer",
		"image": "https://ichef.bbci.co.uk/images/ic/$recipe/p0482fj9.jpg",
		"link": "http://www.bbc.co.uk/iplayer/episode/b07xd230"
	},
];



/** WEBPACK FOOTER **
 ** ./assets/js/config/suggestions.js
 **/